import { render, staticRenderFns } from "./BulkDeleteProgress.vue?vue&type=template&id=4a546b95"
import script from "./BulkDeleteProgress.vue?vue&type=script&lang=js"
export * from "./BulkDeleteProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports